export default "__VITE_ASSET__De$F9eP___"